module.exports = __webpack_public_path__ + "static/media/er_logo_collage.6d4abd35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/er_logo_collage.png
// module id = 301
// module chunks = 0